import { ReactComponent as SalesgearLogo } from "Assets/logo/svg/logo.svg";
import Button from "Components/common/Button";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { googleOAuthPopupState } from "./googleOAuthPopup";
import InboxImage from "./InboxImage";
import connectedInboxStore from "./store";

const FirstTimeWarming = observer(() => {
  const [loader, setLoader] = useState(false);

  const resetPopup = () => {
    googleOAuthPopupState.setShowPopup(false);
    googleOAuthPopupState.setScreenNo("one");
    connectedInboxStore.setFirstTimeEnableWarming(false);
    googleOAuthPopupState.setConnectConfig("oAuth");
  };

  const clickAllowBtn = async () => {
    setLoader(true);
    const enableOrDisableWarming =
      await connectedInboxStore.enableOrDisableWarming(
        googleOAuthPopupState?.inboxData,
        connectedInboxStore?.inboxScreentype === "one" ? "one" : "two"
      );
    if (enableOrDisableWarming) {
      setLoader(false);
      resetPopup();
      connectedInboxStore.getWarmingCommunityMsgShown(true);
    }
  };

  const btnProps = [
    {
      id: "back",
      name: "backBtn",
      icon: false,
      type: "button",
      className: "backBtn",
      loader: false,
      btnText: "Cancel",
      click: resetPopup
    },
    {
      id: "proceedBtn",
      name: "proceedBtn",
      icon: false,
      type: "button",
      className: `proceedBtn ${loader ? "loading" : ""}`,
      loader,
      btnText: "Allow",
      click: clickAllowBtn
    }
  ];

  const closeAction = () => {
    googleOAuthPopupState.setShowPopup(false);
    googleOAuthPopupState.setScreenNo("one");
    googleOAuthPopupState.setConnectConfig("oAuth");
  };

  const getEmailInitial = (email = "") => {
    return email?.[0];
  };

  useEffect(() => {
    return () => {
      setLoader(false);
    };
  }, []);

  return (
    <div className="firstTimeWarmingWrapper">
      <div className="cardHeader OAuthPopupHeader">
        <InboxImage type={googleOAuthPopupState?.inboxData?.type || "google"} />
        <span className="connectTxt">Connect Your Email Account</span>
        <div
          className="OAuthPopupClose"
          title="Click here to close"
          onClick={closeAction}
        >
          <i className="material-icons">close</i>
        </div>
      </div>
      <div className="cardBody OAuthPopupBody">
        <div className="topWrapper">
          <div className="salesgearLogoIcon">
            <SalesgearLogo />
          </div>
          <div className="salesgearAllowAccessContent">
            <a>SalesIntel</a>
            <span>{` wants to access your email Account`}</span>
          </div>
          <div className="emailContent">
            <div className="emailInitials">
              {getEmailInitial(googleOAuthPopupState?.inboxData?.email)}
            </div>
            <div>{googleOAuthPopupState?.inboxData?.email}</div>
          </div>
        </div>
        <div className="finalWrapper">
          <strong>
            Make sure that you trust <a>SalesIntel</a>
          </strong>
          <p className="content">
            Your email account will be used to send and receive randomly
            auto-generated emails in a community of real email addresses to warm
            it up.
          </p>
          <p>
            Please contact{" "}
            <a
              target="_blank"
              className="supportMailLink"
              rel="noopener noreferrer"
              href="mailto:support@salesgear.io"
            >
              support@salesgear.io
            </a>{" "}
            if you have any questions.
          </p>
        </div>
        <div className="oAuthFooter">
          <div className="actionBtns">
            {btnProps.map((item, index) => {
              return <Button {...item} key={index} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
});

export { FirstTimeWarming };
export default FirstTimeWarming;
